import { XLoader } from '@orderx/lab/ui';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--x-color-overlay);
    padding: var(--x-gap2);
`;

export function UiOverlayLoader() {
    return (
        <Wrapper>
            <XLoader />
        </Wrapper>
    );
}
